import React, { Component } from 'react';
import { Spin, Button } from 'antd';
import API_URL from '../../common/url';
import DateRange from '../common/DateRange.new.js';
import Highcharts from 'react-highcharts';
import chartsConfig from '../common/chartsConfig';
import $ from '../../common/AjaxRequest';
import moment from 'moment';

const monthFormat = 'YYYY-MM';

class Charts extends Component {
    render() {
        const { title, chartConfig, searchBar } = this.props;
        const { format, tooltip = {}, series, categories } = chartConfig;
        const config = {
            title: {
                text: ''
            },
            chart: {
                type: 'line',
                zoomType: 'xy',
                height: 600,
            },
            legend: {
                align: 'right',
                verticalAlign: 'top',
                x: 0,
                y: 20,
                layout: 'vertical',
            },
            tooltip,
            yAxis: [{
                title: {
                    text: ''
                },
            }, {
                title: {
                    text: ''
                },
                opposite: true,
                labels: {
                    format,
                },
            }],
            xAxis: {
                categories,
            },
            series,
            exporting: {
                chartOptions: {
                    plotOptions: {
                        series: {
                            dataLabels: {
                                enabled: true
                            }
                        }
                    }
                }
            },
            plotOptions: {
                series: {
                    animation: false
                }
            },
            credits: {
                enabled: false,
                text: 'SMO医疗大数据',
            },
        };
        return (
            <div>
                <div className="T-tit">
                    <div className="txt">
                        <h3 style={{ marginBottom: 10 }}>{title}</h3>
                    </div>
                </div>
                {searchBar}
                <div className="charts" style={{ marginBottom: 20 }}>
                    <Highcharts config={{ ...config, ...chartsConfig }} />
                </div>
            </div>
        )
    }
}

class PlanChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataList: [],
            categories: [],
            tableData: {},
            searchParams: {
                begin: '', //moment().subtract(11, 'M').format(monthFormat),
                end: '' //moment().format(monthFormat),
            },
        };
    }

    componentDidMount() {
        const { plan, blindInvId } = this.props;
        const searchParams = {};
        if(plan && plan.planAmount > 0){
            searchParams.begin = '';
            searchParams.end = '';
        }
        else{
            searchParams.begin = moment().format(monthFormat);
            searchParams.end = moment().add(11,'M').format(monthFormat);
        }
        searchParams.blindInvId = blindInvId;
        this.setState({ searchParams },()=>this.loadData())
        chartsConfig.exporting.buttons.contextButton.menuItems = [
            'downloadJPEG', 'downloadPDF', 'downloadPNG', 'downloadSVG',
        ];
    }

    // componentDidUpdate(prevProps) {
    //     if (!prevProps.visible && this.props.visible) {
    //         this.setState({
    //             searchParams: {
    //                 begin: moment().subtract(11, 'M').format(monthFormat),
    //                 end: moment().format(monthFormat),
    //             },
    //             investigationSiteList: [],
    //         }, () => {
    //             this.loadData();
    //         });
    //     }
    // }

    loadData = () => {
        const { searchParams } = this.state;
        const { begin,end,blindInvId } = searchParams || {};
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.plan.queryInvMonthlyPlanStatistic,
            data: {
                leftYear: begin ? moment(begin).year() : undefined,
                leftMonth: begin ? moment(begin).month()+ 1 : undefined,
                rightYear: end ? moment(end).year() : undefined,
                rightMonth: end ? moment(end).month()+ 1 : undefined,
                blindInvId,
            },
            dateType: 'json',
            doneResult: res => {
                const { statistics = [] } = res.data;
                const categories = (statistics|| []).map(i => `${i.year}.${i.month}`);
                const filterAccumulation = [] , filterAmount =[] , informedAccumulation =[], informedAmount =[], randomAccumulation =[], randomAmount =[],actualAccumulation =[],actualAmount=[];
                (statistics|| []).map(i => {
                    filterAccumulation.push(i.filterAccumulation);
                    filterAmount.push(i.filterAmount);
                    informedAccumulation.push(i.informedAccumulation);
                    informedAmount.push(i.informedAmount);
                    randomAccumulation.push(i.randomAccumulation);
                    randomAmount.push(i.randomAmount);
                    actualAccumulation.push(i.actualAccumulation);
                    actualAmount.push(i.actualAmount);
                });
                this.setState({
                    loading: false,
                    categories,
                    tableData:{
                        filterAccumulation,filterAmount,informedAccumulation,informedAmount,randomAccumulation,randomAmount,actualAccumulation,actualAmount
                    },
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    
    handleDateChange = (value) => {
        const { searchParams } = this.state;
        const [begin, end] = value;
        searchParams.begin = begin;
        searchParams.end = end;
        this.setState({ searchParams });
    }

    getSearchBar = () => {
        const { searchParams } = this.state;
        const { begin, end } = searchParams;
        return (
            <div style={{marginBottom:5}}>
                时间&nbsp;<DateRange
                    allowClear={false}
                    value={[begin, end]}
                    style={{width: 100}}
                    disabledDate={[11, 'M']}
                    onChange={value => this.handleDateChange(value, 'dateRange')}
                />
            &nbsp;&nbsp;<Button type='primary' onClick={this.loadData}>统计</Button>
        </div>
            
        )
    }
 
    render() {
        const { loading, categories, tableData } = this.state;
        const { isGivenSecondLines } = this.props;
        const seriesData = [{
            data: tableData.randomAmount || [],
            name: '每月计划随机(入组)数',
            type: 'column',
        }, {
            data: tableData.informedAmount || [],
            name: '每月计划知情数',
            type: 'column',
        },{
            data: tableData.filterAmount || [],
            name: '每月计划筛选数',
            type: 'column',
        }];
        
        if (isGivenSecondLines) {
            seriesData.push({
                data: tableData.actualAmount || [],
                name: '每月实际随机（入组）数',
                type: 'column',
            });
        }

        seriesData.push({
            data: tableData.randomAccumulation || [],
            name: '累计计划随机(入组)数',
            type: 'line',
            yAxis:1,
        },{
            data: tableData.informedAccumulation || [],
            name: '累计计划知情数',
            type: 'line',
            yAxis:1,
        },{
            data: tableData.filterAccumulation || [],
            name: '累计计划筛选数',
            type: 'line',
            yAxis:1,
        });

        if (isGivenSecondLines) {
            seriesData.push({
                data: tableData.actualAccumulation || [],
                name: '累计实际随机（入组）数',
                type: 'line',
                yAxis:1,
            });
        }


        const proChartConfig = {
            format: '{value}',
            categories,
            series: seriesData,
        };
        return (
            <div className="content">
                <div>
                    <Spin spinning={loading}>
                        <Charts
                                //title="累计完成访视数VS.累计消耗FTE数"
                                chartConfig={proChartConfig}
                                searchBar={this.getSearchBar()}
                        />
                    </Spin>
                </div>
            </div>
        );
    }
}

export default PlanChart;


// WEBPACK FOOTER //
// ./src/components/plan/PlanChart.js